import {
  query as queryUsers,
  queryCurrent,
  queryStore,
} from "../services/user";
import local from "../utils/local";
import action from "./action";

const KEY_STORE = "shop";

export default {
  namespace: "user",

  state: {
    list: [],
    currentUser: {},
    currentStore: local.get(KEY_STORE) || null,
    visibleStore: false,
  },

  effects: {
    *fetch(_, { call, put }) {
      const response = yield call(queryUsers);
      yield put({
        type: "save",
        payload: response,
      });
    },
    *fetchCurrent({ menus, callback }, { call, put }) {
      try {
        const response = yield call(queryCurrent);
        console.log(`🚀 ~ file: user.js ~ line 31 ~ *fetchCurrent ~ response`, response);
        yield put({
          type: "saveCurrentUser",
          payload: response.user,
        });
        if (response.store) {
          yield put({
            type: "saveCurrentStore",
            payload: response.store,
          });
        }
        if (response.role) {
          yield put({
            type: "saveCurrentRole",
            payload: response.role,
          });
        }
        if (response.partner) {
          yield put({
            type: "saveCurrentPartner",
            payload: response.partner,
          });
        }
        console.log("response",response.role)
        const roleArray = response.role
        const PARTNER_ID =  process.env.PARTNER_ID || 1
        const filteredItem = roleArray.find(item => item.partner_id === PARTNER_ID) 
        console.log("partner_id",process)
        console.log("filteredItem",filteredItem)
        let role = filteredItem || response.role[0]
        console.log("role",role)
        let roleItems = role.role_items;
        if (!Array.isArray(roleItems)) {
          local.set("roles", JSON.stringify({}));
        }
        let pers = {};
        roleItems.forEach((e) => {
          let model = e.model
          let actions = e.actions
          let action =''
          actions.forEach((a) => {
            action= action+ a.shortcut
          })
          console.log("model",model)
          console.log("action",action)
          if (model != undefined) {
            pers[model.shortcut] = action;
          }  
        });
        console.log("per",pers)
        local.set("roles", JSON.stringify(pers));
        if (role.role) local.set("rolename", role.role);
        yield put({
          type: "menu/setRoles",
          payload: pers,
        });
        yield put({
          type: "menu/getMenuData",
          payload: { routes: menus },
        });
        try {
          if (callback) {
            callback(response.user);
          }
        } catch (error) {
          console.log(`🚀 ~ file: user.js ~ line 71 ~ *fetchCurrent ~ error`, error);
        }
      } catch (error) {
        console.log(`🚀 ~ file: user.js ~ line 136 ~ *fetchCurrent ~ error`, error);
      }

    },
    *fetchStore(_, { call, put }) {
      const response = yield call(queryStore);
      yield put({
        type: "saveCurrentStore",
        payload: response,
      });
    },
    *setStore({ payload, callback }, { call, put, all }) {
      local.set(KEY_STORE, JSON.stringify(payload));
      yield all([
        yield put({
          type: "saveCurrentStore",
          payload,
        }),
        yield put({
          type: "saveVisibleStore",
          payload: false,
        }),
      ]);
    },
    *setVisibleStore({ payload, callback }, { call, put }) {
      yield put({
        type: "saveVisibleStore",
        payload,
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        list: action.payload,
      };
    },
    saveCurrentUser(state, action) {
      return {
        ...state,
        currentUser: action.payload || {},
      };
    },
    saveCurrentStore(state, action) {
      return {
        ...state,
        currentStore: action.payload || {},
      };
    },
    saveCurrentRole(state, action) {
      return {
        ...state,
        currentRole: action.payload || {},
      };
    },
    saveCurrentPartner(state, action) {
      return {
        ...state,
        currentPartner: action.payload || {},
      };
    },
    saveVisibleStore(state, action) {
      return {
        ...state,
        visibleStore: action.payload || false,
      };
    },
    changeNotifyCount(state, action) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          notifyCount: action.payload.totalCount,
          unreadCount: action.payload.unreadCount,
        },
      };
    },
  },
};
